import { supabase } from '../supabase';
import { Ship } from '../utils/types';

export async function getShips(): Promise<Ship[]> {
  const { data, error } = await supabase
    .from('ships')
    .select(`
      *,
      trips_count:ship_trips!ship_id(count)
    `)
    .order('name');

  if (error) {
    console.error('Error fetching ships:', error);
    return [];
  }

  return data;
}

export async function getShipById(id: number): Promise<Ship | null> {
  const { data, error } = await supabase
    .from('ships')
    .select('*')
    .eq('id', id)
    .single();

  if (error) {
    console.error('Error fetching ship:', error);
    return null;
  }

  return data;
}

export async function getShipByName(name: string): Promise<Ship | null> {
  const { data, error } = await supabase
    .from('ships')
    .select('*')
    .eq('name', name)
    .single();

  if (error) {
    console.error('Error fetching ship by name:', error);
    return null;
  }

  return data;
}

export async function createShip(ship: Omit<Ship, 'id'>): Promise<Ship | null> {
  const { data, error } = await supabase
    .from('ships')
    .insert([ship])
    .select()
    .single();

  if (error) {
    console.error('Error creating ship:', error);
    return null;
  }

  return data;
}

export async function updateShip(
  id: number,
  ship: Partial<Ship>
): Promise<Ship | null> {
  const { data, error } = await supabase
    .from('ships')
    .update(ship)
    .eq('id', id)
    .select()
    .single();

  if (error) {
    console.error('Error updating ship:', error);
    return null;
  }

  return data;
}

export async function deleteShip(id: number): Promise<boolean> {
  const { error } = await supabase.from('ships').delete().eq('id', id);

  if (error) {
    console.error('Error deleting ship:', error);
    return false;
  }

  return true;
}
